<footer class="site-footer">
  <div class="footer-card">
    <div class="footer-col">
      <div class="footer-ico" style="background: #e3edfd; color: #1d4ed8">
        <i class="fa-solid fa-share-nodes" aria-hidden="true"></i>
      </div>
      <h3>Redes</h3>
      <div class="footer-lines">
        <a [href]="instagramUrl" target="_blank" class="footer-line">
          <span class="footer-line-ico"
            ><i class="fab fa-instagram" aria-hidden="true"></i></span
          >{{ instagramHandle }}
        </a>
        <button
          type="button"
          (click)="mensajeWhatsapp()"
          class="footer-line footer-line-btn"
        >
          <span class="footer-line-ico"
            ><i class="fab fa-whatsapp" aria-hidden="true"></i></span
          >{{ whatsappNumero }}
        </button>
        <a
          href="https://search.google.com/local/writereview?placeid=ChIJQbZP-QVFlJURCUmegNenhQs"
          target="_blank"
          rel="noopener"
          class="footer-line"
        >
          <span class="footer-line-ico"
            ><i class="fa-solid fa-star" aria-hidden="true"></i></span
          >Dejá tu reseña
        </a>
      </div>
    </div>

    <div class="footer-col">
      <div class="footer-ico" style="background: #ede7fb; color: #6d28d9">
        <i class="fa-solid fa-clock" aria-hidden="true"></i>
      </div>
      <h3>Horarios</h3>
      @if (horarios) {
        <div class="footer-lines" [innerHTML]="horariosLineas"></div>
      } @else {
        <div class="footer-lines">
          <button
            type="button"
            (click)="mensajeWhatsapp()"
            class="footer-line footer-line-btn"
          >
            <span class="footer-line-ico"
              ><i class="fab fa-whatsapp" aria-hidden="true"></i></span
            >Consultá por WhatsApp
          </button>
        </div>
      }
    </div>

    <div class="footer-col">
      <div class="footer-ico" style="background: #e3edfd; color: #1d4ed8">
        <i class="fa-solid fa-location-dot" aria-hidden="true"></i>
      </div>
      <h3>Dirección</h3>
      <div class="footer-lines footer-lines-desktop-address">
        <a [href]="urlMaps" target="_blank" class="footer-line"
          >San Lorenzo 2586 Oficina 1.</a
        >
        <a [href]="urlMaps" target="_blank" class="footer-line">Olavarría</a>
      </div>
      <div class="footer-lines footer-lines-mobile-address">
        <a [href]="urlMaps" target="_blank" class="footer-line"
          >San Lorenzo 2586 Oficina 1, Olavarría</a
        >
      </div>
    </div>

    <div class="footer-map-col" #mapaCol>
      <a
        class="footer-map"
        [href]="urlMaps"
        target="_blank"
        aria-label="Ver ubicación en Google Maps"
      >
        @if (mapaVisible) {
          <iframe
            [src]="mapsEmbedUrlSafe"
            title="Ubicación de SOY iPhone"
          ></iframe>
        }
      </a>
    </div>
  </div>

  <div class="footer-copy">
    <p>&copy; {{ anioActual }} SOY iPhone. Todos los derechos reservados.</p>
    <p>
      Creado por
      <a href="https://devtwp.vercel.app" target="_blank">TWP Software</a>
    </p>
  </div>
</footer>
